import styled from 'styled-components'
import { SecondaryButton } from './Button'
import { RADOM_COLORS } from '../util/Constants'
import React, { ReactNode } from 'react'
import PaymentMethodDisplay from './PaymentMethodDisplay'
import { DepositAccountDetails, FiatAccountType, FiatDepositAccountType, WithdrawalAccountDetails } from '../state/Radom'

export const DateRange = styled(SecondaryButton)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  color: ${RADOM_COLORS.BLACK};
  border: 0;
`

export const SectionBreakerHorizontal = styled.div`
  width: 100%;
  border-bottom: 1px solid ${RADOM_COLORS.GRAY_DARK};
`

export const SectionBreakerVertical = styled.div`
  height: 100%;
  border-left: 1px solid ${RADOM_COLORS.GRAY_DARK};
`

export const ClickableSection = styled.div`
  padding: 20px 16px;
  border-radius: 10px;
  border: 1px solid ${RADOM_COLORS.GRAY_DARK};
  boxShadow: 0 0 3px ${RADOM_COLORS.GRAY_DARK};
  display: flex;
  flex-direction: column;
  gap: 30px;
  &:hover {
    background-color: ${RADOM_COLORS.GRAY_LIGHTEST};
  };
  background-color: ${RADOM_COLORS.WHITE}, 
`

export const formatFiatAccountType = (accountDetails: FiatAccountType): ReactNode => {
  return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

    <img
      style={{
        width: 25,
        maxHeight: 25,
        maxWidth: 25
      }}
      src={`https://pay.radom.com/flags/${accountDetails.accountType.us ? 'us' : 'eu'}.svg`}
    />

    <span>{accountDetails.accountType.us ? 'US' : 'EU'} Bank Account</span>
  </div>
}

export const formatFiatAccountDetails = (accountDetails: FiatAccountType): ReactNode => {
  if (accountDetails.accountType.us) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      {accountDetails.accountOwnerName}
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.accountType.us?.bankName}</span>
      </div>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Account #</span>
        <span>{accountDetails.accountType.us?.accountNumber}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Routing #</span>
        <span>{accountDetails.accountType.us?.routingNumber}</span>
      </div>
    </div>
  }

  if (accountDetails.accountType.iban) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      {accountDetails.accountOwnerName}
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>IBAN #</span>
        <span>{accountDetails.accountType.iban?.iban}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>BIC #</span>
        <span>{accountDetails.accountType.iban?.bic}</span>
      </div>
    </div>
  }

  return <></>
}

export const formatDepositFiatAccountType = (accountDetails: FiatDepositAccountType): ReactNode => {
  return <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>

    <img
      style={{
        width: 20,
        maxHeight: 20,
        maxWidth: 20
      }}
      src={`https://pay.radom.com/flags/${accountDetails.accountType.us ? 'us' : 'eu'}.svg`}
    />

    <span>{accountDetails.accountType.us ? 'US' : 'EU'} Bank Account</span>
  </div>
}

export const formatDepositFiatAccountDetails = (accountDetails: FiatDepositAccountType): ReactNode => {
  if (accountDetails.accountType.us) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.bankName}</span>
      </div>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Account #</span>
        <span>{accountDetails.accountType.us?.accountNumber}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Routing #</span>
        <span>{accountDetails.accountType.us?.routingNumber}</span>
      </div>
    </div>
  }

  if (accountDetails.accountType.iban) {
    return <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5, flexDirection: 'column' }}>
      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>Bank</span>
        <span>{accountDetails.bankName}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>IBAN #</span>
        <span>{accountDetails.accountType.iban?.iban}</span>
      </div>

      <div style={{ fontSize: 12, display: 'flex', gap: 5, alignItems: 'center' }}>
        <span style={{ textTransform: 'uppercase', opacity: 0.5, fontSize: 10 }}>BIC #</span>
        <span>{accountDetails.accountType.iban?.bic}</span>
      </div>
    </div>
  }

  return <></>
}

export const formatWithdrawalAccountType = (accountDetails: WithdrawalAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return <PaymentMethodDisplay method={{ network: accountDetails.Crypto.network }} />
  }

  if (accountDetails.Fiat) {
    return formatFiatAccountType(accountDetails.Fiat)
  }

  return ''
}

export const formatWithdrawalAccount = (accountDetails: WithdrawalAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return accountDetails.Crypto.address
  }

  if (accountDetails.Fiat) {
    return formatFiatAccountDetails(accountDetails.Fiat)
  }

  return ''
}

export const formatDepositAccountType = (accountDetails: DepositAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      {
        accountDetails.Crypto.depositMethods.slice(0, 3).map(m =>

          <PaymentMethodDisplay
            key={m.network + (m.token ?? '')}
            method={{ network: m.network, token: m.token }}
            excludeName
            disableTooltip={false} />
        )
      }
      {accountDetails.Crypto.depositMethods.length > 3 && `+${accountDetails.Crypto.depositMethods.length - 3}`}
    </div>
  }

  if (accountDetails.Fiat) {
    return formatDepositFiatAccountType(accountDetails.Fiat)
  }

  return ''
}

export const formatDepositAccount = (accountDetails: DepositAccountDetails): ReactNode => {
  if (accountDetails.Crypto) {
    return accountDetails.Crypto.address
  }

  if (accountDetails.Fiat) {
    return formatDepositFiatAccountDetails(accountDetails.Fiat)
  }

  return ''
}

export const SubTitle = styled.div`
  font-size: 14px;
  color: ${RADOM_COLORS.GRAY_DARKEST};
  display: flex;
  align-items: center;
  gap: 3px;
`

export const Section = styled.div`
  padding: 30px;
  border-radius: 10px;
  border: 1px solid ${RADOM_COLORS.GRAY_DARK};
  boxShadow: 0 0 3px ${RADOM_COLORS.GRAY_DARK};
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const SectionContent = styled.div<{ numColumns?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ numColumns }) => numColumns || 2}, 1fr);
  flex-wrap: wrap;
  gap: 30px;
`

export const SectionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SectionBreaker = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed ${RADOM_COLORS.GRAY_DARK};
`
